var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutcomes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Outcomes & Progress") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chart-line-up-solid",
    d: "M3,33.5a1.5,1.5,0,1,0-3,0V49.25A3.749,3.749,0,0,0,3.75,53H22.5a1.5,1.5,0,1,0,0-3H3.75A.752.752,0,0,1,3,49.25ZM20.578,43.578a1.126,1.126,0,0,0,1.922-.8V37.625A1.122,1.122,0,0,0,21.375,36.5H16.214a1.126,1.126,0,0,0-.8,1.922l1.519,1.519L14.25,42.627l-3.441-3.441a1.5,1.5,0,0,0-2.123,0l-3.75,3.75a1.5,1.5,0,1,0,2.123,2.123L9.75,42.373l3.441,3.441a1.5,1.5,0,0,0,2.123,0l3.75-3.75Z",
    transform: "translate(0 -32)",
    fill: "inharit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutcomes);
export default __webpack_public_path__ + "static/media/outcomes.d3d617defca5f0adcf12fb94fbb109a8.svg";
export { ForwardRef as ReactComponent };